import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-app-redirect',
  templateUrl: './mobile-app-redirect.component.html',
  styleUrls: ['./mobile-app-redirect.component.css']
})
export class MobileAppRedirectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.redirectToPlayStore();
  }

  redirectToPlayStore() {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.app.puja_prasad';
  }

}



// WEBPACK FOOTER //
// ./src/app/devotee/mobile-app-redirect/mobile-app-redirect.component.ts